import { FieldContext, ValidationResult } from "@angular/forms/signals";
import { Marketplace, SbCreativeType } from "@front/m19-api-client";
import { headlineLimit } from "@front/m19-models/SbLimits";

export const SB_BRAND_NAME_REGEX =
  /^[- $'%&()*+,./:;<=>`_|{}~0-9a-zA-ZÁÍÑÓÚáéíñóúÄÖßäöüÀÂÆÇÈÉÊËÎÏÌÌÔÙÛÜŒŸàâæçèêëîïìôùûÿœ\\[\]\u0022\u3000-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uFF00-\uFFEF]+$/;

export const SB_CAPS_REGEX = /^[A-Z0-9ÀÂÆÇÈÉÊËÎÏÔÙÛÜŒŸÁÍÑÓÚ',: ]+$/;

export function validateSbBrandName(context: FieldContext<string>): ValidationResult {
  const value = context.value();
  if (value && !SB_BRAND_NAME_REGEX.test(value)) {
    return { kind: "invalidName", message: "sb-form-creative.headline_contains_invalid_characters" };
  }
  return null;
}

export function validateSbHeadline(
  creativeType: SbCreativeType,
  marketplace: Marketplace | undefined,
): (context: FieldContext<string>) => ValidationResult {
  return (context) => {
    const headline = context.value();
    if (!headline) {
      return null;
    }
    if (SB_CAPS_REGEX.test(headline)) {
      return {
        kind: "capsError",
        message: "sb-form-creative.the_headline_cannot_consist_solely_of_capital_letters",
      };
    }
    if (!SB_BRAND_NAME_REGEX.test(headline)) {
      return { kind: "invalidName", message: "sb-form-creative.headline_contains_invalid_characters" };
    }
    if (headline.length > headlineLimit(creativeType, marketplace)) {
      return { kind: "headlineTooLong", message: "sb-form-creative.headline_max_length" };
    }
    return null;
  };
}
